import * as React from 'react'

const ArrowUp = (props: { className: string }) => (
  <svg
    className={'icon ' + props.className}
    width='11'
    height='7'
    viewBox='0 0 11 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='0.262'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.71667 7L5.5 2.64865L1.28333 7L0 5.67568L5.5 0L11 5.67568L9.71667 7Z'
      fill='#000'
    />
  </svg>
)

export default ArrowUp



// WEBPACK FOOTER //
// ./src/components/icons/ui/ArrowUp.tsx